import { AppointmentTypes } from '@src/js/constants.js';
import { DOM_EVENTS } from "@js/constants/constants-imports.es6.js";

export const VISIT_TYPE_ELEMENT_IDS = {
  IN_PERSON: 'field-form-element-visit-type--in-person-visit',
  TELEHEALTH: 'field-form-element-visit-type--telehealth-visit',
};

export default class ConfirmationUtils {
  static setSelect2Value(id, value) {
    const $element = $(`#${id}`);
    $element.val(value);

    var selectedOptionData = $element.select2('data')[0];

    // Triggers a visual update of the select2
    $element.trigger(DOM_EVENTS.CHANGE);

    // Manually fire select2 update event with data
    $element.trigger({
      type: DOM_EVENTS.SELECT2_SELECT,
      params: {
        data: selectedOptionData,
      }
    });
  }

  static setCondition(mnemonic) {
    ConfirmationUtils.setSelect2Value('field-form-element-condition', mnemonic);
  }

  static setVisitType(appointmentType) {
    if (appointmentType) {
      if (appointmentType === AppointmentTypes.IN_PERSON) {
        document.getElementById(
          VISIT_TYPE_ELEMENT_IDS.IN_PERSON,
        ).checked = true;
        document.getElementById(
          VISIT_TYPE_ELEMENT_IDS.TELEHEALTH,
        ).checked = false;
      } else {
        document.getElementById(
          VISIT_TYPE_ELEMENT_IDS.IN_PERSON,
        ).checked = false;
        document.getElementById(
          VISIT_TYPE_ELEMENT_IDS.TELEHEALTH,
        ).checked = true;
      }

      ConfirmationUtils.updateHighlightRadio();
    } else {
      ConfirmationUtils.clearVisitType();
    }
  }

  static setLocation(epicDepartmentId) {
    ConfirmationUtils.setSelect2Value('location-select', epicDepartmentId);
  }

  static disableVisitTypeIfEmpty(providerAllSlots) {
    // this will happen if we did not come in with a pre-selected mnemonic.
    if (providerAllSlots.hasInPersonSlots === undefined) {
      ConfirmationUtils.clearVisitType();
      return;
    }

    if (!providerAllSlots.hasInPersonSlots) {
      document.getElementById(VISIT_TYPE_ELEMENT_IDS.IN_PERSON).disabled = true;
    } else if (!providerAllSlots.hasTelehealthSlots) {
      document.getElementById(
        VISIT_TYPE_ELEMENT_IDS.TELEHEALTH,
      ).disabled = true;
    }
    ConfirmationUtils.updateHighlightRadio();
  }

  static clearVisitType() {
    document.getElementById(VISIT_TYPE_ELEMENT_IDS.IN_PERSON).checked = false;
    document.getElementById(VISIT_TYPE_ELEMENT_IDS.IN_PERSON).disabled = false;
    document
      .getElementById(VISIT_TYPE_ELEMENT_IDS.IN_PERSON)
      .parentElement.classList.remove('disabled');
    document.getElementById(VISIT_TYPE_ELEMENT_IDS.TELEHEALTH).checked = false;
    document.getElementById(VISIT_TYPE_ELEMENT_IDS.TELEHEALTH).disabled = false;
    document
      .getElementById(VISIT_TYPE_ELEMENT_IDS.TELEHEALTH)
      .parentElement.classList.remove('disabled');
    ConfirmationUtils.updateHighlightRadio();
  }

  static updateHighlightRadio() {
    const parentSelected = document.querySelectorAll(
      'input[type="radio"]:checked',
    );
    const parentNotSelected = document.querySelectorAll(
      'input[type="radio"]:not(:checked)',
    );
    const parentDisabled = document.querySelectorAll(
      'input[type="radio"]:disabled',
    );

    parentSelected.forEach(selected => {
      selected.parentElement.classList.add('selected');
      selected.parentElement.classList.remove('disabled');
    });

    parentNotSelected.forEach(notSelected => {
      notSelected.parentElement.classList.remove('selected');
    });

    parentDisabled.forEach(notSelected => {
      notSelected.parentElement.classList.add('disabled');
    });
  }
}
